import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./SideBar";
import Topbar from "./Topbar";
import { SIDEBAR_WIDTH } from "../constants";
import { useEffect, useState } from "react";
import { useLazyGetUserQuery } from "../services/auth";
import { getFromStorage } from "../helpers";
import { STORAGE_KEYS } from "../constants/storagekeys";
import { setCredentials } from "../reducers/authSlice";
import secureLocalStorage from "react-secure-storage";
import { useAppDispatch } from "../hooks/store";

function MainContainer({ hideHeader = false }: { hideHeader?: boolean }) {
  const dispatch = useAppDispatch();
  const [getUser] = useLazyGetUserQuery();

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

   const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);

    try {
      const result = await getUser({}).unwrap();
      if (result?.statusCode === 200 && token) {
        // secureLocalStorage.setItem('permissions', JSON.stringify(result?.data?.role_permission));
        secureLocalStorage.setItem('role', result?.data?.role);
        dispatch(
          setCredentials({
            user: result?.data,
            token,
          }),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <>
      {!hideHeader && <Topbar handleSidebarToggle={handleSidebarToggle} />}
      <Sidebar
        mobileOpen={mobileOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
      <Box
        component="main"
        className="main_content"
        sx={{
          marginLeft: "auto",
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        <Container className="sub-layout">
          <Outlet />
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
